import { useState } from 'react'
import docsNav from '../../config/docs-nav.json'
import LanguageSwitcher from './LanguageSwitcher'

export default function DocsSidebar({ locale, currentSection, currentPage }) {
  const initialOpen = docsNav.sections.reduce((acc, section) => {
    acc[section.key] = section.pages.some(p => p.key === currentPage) && section.key === currentSection
    return acc
  }, {})

  const [openSections, setOpenSections] = useState(initialOpen)

  function toggleSection(key) {
    setOpenSections(prev => ({ ...prev, [key]: !prev[key] }))
  }

  return (
    <aside className="w-56 shrink-0 border-r border-zinc-800 px-3 py-4 sticky top-0 h-full overflow-y-auto flex flex-col gap-4">
      <LanguageSwitcher locale={locale} section={currentSection} page={currentPage} />
      <nav className="space-y-1">
        {docsNav.sections.map(section => {
          const isOpen = openSections[section.key]
          const sectionLabel = section.label[locale] || section.label.en

          return (
            <div key={section.key}>
              <button
                onClick={() => toggleSection(section.key)}
                className="flex items-center justify-between w-full px-2 py-1 text-[10px] font-mono font-semibold tracking-widest text-zinc-500 hover:text-zinc-300 uppercase transition-colors"
              >
                <span>{sectionLabel}</span>
                <span className={`transition-transform duration-200 ${isOpen ? 'rotate-0' : '-rotate-90'}`}>▾</span>
              </button>
              {isOpen && (
                <div className="mt-0.5 space-y-0.5">
                  {section.pages.map(p => {
                    const isActive = section.key === currentSection && p.key === currentPage
                    const pageLabel = p.label[locale] || p.label.en

                    return (
                      <a
                        key={p.key}
                        href={`/docs/${locale}/${section.key}/${p.key}`}
                        className={[
                          'block px-4 py-1 rounded text-xs font-mono transition-colors',
                          isActive
                            ? 'text-emerald-400 font-semibold'
                            : 'text-zinc-400 hover:text-zinc-200',
                        ].join(' ')}
                      >
                        {pageLabel}
                      </a>
                    )
                  })}
                </div>
              )}
            </div>
          )
        })}
      </nav>
    </aside>
  )
}
